import { render, staticRenderFns } from "./SlidingBaySizeAndGlazing.vue?vue&type=template&id=3f4f2516&scoped=true"
import script from "./SlidingBaySizeAndGlazing.vue?vue&type=script&lang=ts"
export * from "./SlidingBaySizeAndGlazing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4f2516",
  null
  
)

export default component.exports